<ng-container *ngIf="isUserCheckComplete">
    <login-background *ngIf="inviteCodeError; else registerForm">
        <h2>Something went wrong.</h2>
        <p>{{ inviteCodeError }}</p>
    </login-background>
</ng-container>

<ng-template #registerForm>
    <app-register-form></app-register-form>
</ng-template>
